import { useState } from 'react'
import { PageHeader } from '../../../shared/components'
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AdministrationPaths } from '../../../shared/api/constants';
import { AppPaths } from '../../../shared/appConstants';
import { AlertComponent } from '../../../shared/components';
import { Icon } from '../../../shared/components';
import { useApi } from '../../../shared/hooks/useApi';
import { useApiHandleError } from '../../../shared/hooks/useApiHandleError';
import { SpinnerComponent } from '../../../shared/components';
import { Required } from '../../../shared/components';

export function CreateCategory() {
  const { setError, errorMessage } = useApiHandleError();
  const [loading, setIsLoading] = useState(false);
  const [formError, setFormError] = useState('');
  const goTo = useNavigate();
  const API = useApi();
  const [category, setCategory] = useState('');

  const handleInputChange = (event: any) => {
    if (formError) setFormError('');
    if (errorMessage) setError('');

    setCategory(event.target.value);
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (!category) return setFormError('Category is required.');

    setIsLoading(true);
    (async () => {
      try {
        const response = await API.post(AdministrationPaths.CreateCategory(), { name: category });
        if (response?.data) {
          goTo(AppPaths.getCategories())
        }
      } catch (error) {
        setError(error);
      }
      setIsLoading(false);
    })();
  };

  return (
    <Container>
      <PageHeader pageTitle='Create Category' />
      <AlertComponent message={errorMessage} />
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group controlId="name" className="mt-3">
          <Form.Label className="fw-bold">Category Name<Required /></Form.Label>
          <Form.Control
            size="lg"
            type="text"
            name="category"
            autoComplete="off"
            value={category}
            onChange={handleInputChange}
            autoFocus
            isInvalid={Boolean(formError)}
          />
          <Form.Control.Feedback type="invalid">{formError}</Form.Control.Feedback>
        </Form.Group>

        <Button variant="success" type="submit" className="mx-2 mt-5 fw-bold">
          {loading ? <SpinnerComponent /> : <Icon icon={faCheck} />} Submit
        </Button>
      </Form>
    </Container>
  );
}
